/*
 * Accept-donations.ts
 * Description: Includes the declaration
 * of the function for accepting donations
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';
// Importing get Donations function
import {getDonations} from '@/ts/donations/get-donations';

/**
 * Finishing a donation
 *
 * @return {Object} Promise - response with updated donations
 * @param {Number} score - score of the donation
 * @param {Number} id - id of the donation
 */
export function acceptDonations(id: number, score: number) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'donations/' + id,
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {
                score,
            },
        }).then(() => {
            // TODO: Check if this code is fine
            getDonations().finally(() => {
                resolve();
            });
        }).catch(() => {
            reject();
        });
    });
}
